import Dexie from 'dexie';

class BrantaLocalDb extends Dexie {
	constructor() {
		super('brantaLocalDb');
		this.version(1).stores({
			buddyMessages: '++id, userId, conversationId, createdAt, [userId+conversationId]',
		});
	}
}

export const localDb = new BrantaLocalDb();
